import { cn } from "../../../lib/utils.js";

const customStyles = `
@keyframes mirror-shimmer {
  0% { transform: translateX(-200%) skewX(-20deg); }
  15% { transform: translateX(250%) skewX(-20deg); }
  100% { transform: translateX(250%) skewX(-20deg); }
}
@keyframes subtle-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.65; }
}
`;

// לאודר אלגנטי ומותאם אישית (מחליף את לאודר ברירת המחדל)
function ElegantSpinner(): React.JSX.Element {
  return (
    <svg 
      className="h-[22px] w-[22px] animate-spin text-[#183c32]" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2.5" className="opacity-20" />
      <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="opacity-80" />
    </svg>
  );
}

function GoogleGlyph(): React.JSX.Element {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 48 48" 
      className="h-[22px] w-[22px] shrink-0" 
      aria-hidden="true"
    >
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}

interface GoogleSignInButtonProps {
  label: string;
  loadingLabel: string;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function GoogleSignInButton({
  label,
  loadingLabel,
  loading = false,
  disabled = false,
  onClick,
}: GoogleSignInButtonProps): React.JSX.Element {
  const isDisabled = disabled || loading;

  return (
    <>
      <style>{customStyles}</style>
      <button
        type="button"
        className={cn(
          // הגדלנו פה את הכתב ל-text-[16px]
          "group relative flex h-[55px] w-full min-w-0 overflow-hidden items-center justify-center gap-[13px] rounded-[12px] border border-[#d5e5dc] bg-white px-5 text-[16px] leading-normal font-[800] text-[#183c32]",
          "shadow-[0_7px_25px_#1c503010] transition-all duration-300 ease-out",
          "not-disabled:hover:-translate-y-[2px] not-disabled:hover:border-[#b4cec1] not-disabled:hover:shadow-[0_12px_35px_#1c503020]",
          "not-disabled:active:translate-y-[1px] not-disabled:active:scale-[0.98] not-disabled:active:shadow-md",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#79d9be] focus-visible:ring-offset-2 focus-visible:ring-offset-[#f8faf9]",
          "disabled:cursor-progress disabled:opacity-75"
        )}
        onClick={onClick}
        disabled={isDisabled}
        aria-busy={loading}
      >
        {!isDisabled && (
          <div 
            className="pointer-events-none absolute inset-0 z-0 h-full w-[40%] bg-gradient-to-r from-transparent via-[#a8c6b7]/30 to-transparent mix-blend-multiply"
            style={{ animation: 'mirror-shimmer 4s infinite ease-in-out' }}
            aria-hidden="true"
          />
        )}

        <div className="relative z-10 flex items-center justify-center gap-[13px]">
          {loading ? (
            <>
              <ElegantSpinner />
              {/* אפקט פעימה לטקסט בזמן טעינה */}
              <span className="min-w-0 wrap-anywhere animate-[subtle-pulse_1.5s_ease-in-out_infinite]">{loadingLabel}</span>
            </>
          ) : (
            <>
              <GoogleGlyph />
              <span className="min-w-0 wrap-anywhere">{label}</span>
            </>
          )}
        </div>
      </button>
    </>
  );
}